export class RemovePartnerResult {
  result: boolean;
  message: string;

  static createFromAny(object: any): RemovePartnerResult {
    if (object === null || object === undefined) {
      return null;
    }

    const removePartnerResult = new RemovePartnerResult();
    removePartnerResult.result = object.result || false;
    removePartnerResult.message = object.message || '';

    return removePartnerResult;
  }
}
